import { Iterable, IPlace } from "types";

export const calculateMaxRatingFor = (places: Iterable<IPlace>[]) => {
  return Math.max(...places.map((item) => item.rating.value));
};

export const calculateMaxUserRatingFor = (places: Iterable<IPlace>[]) => {
  return Math.max(...places.map((item) => item.rating.votes_count));
};

export const calculateCustomRating = (
  item: Iterable<IPlace>,
  maxRating: number,
  maxUserRating: number
) => {
  return (
    (item.rating.value / maxRating + item.rating.votes_count / maxUserRating) /
    2
  );
};

export const sortByCustomRating = (places: Iterable<IPlace>[]) => {
  const calculateMaxRatingFor = (places: Iterable<IPlace>[]) => {
    return Math.max(...places.map((item) => item.rating.value));
  };

  const calculateMaxUserRatingFor = (places: Iterable<IPlace>[]) => {
    return Math.max(...places.map((item) => item.rating.votes_count));
  };

  const calculateCustomRating = (
    item: Iterable<IPlace>,
    maxRating: number,
    maxUserRating: number
  ) => {
    return (
      (item.rating.value / maxRating +
        item.rating.votes_count / maxUserRating) /
      2
    );
  };

  const maxRating = calculateMaxRatingFor(places);
  const maxUserRating = calculateMaxUserRatingFor(places);

  return places.sort((a, b) => {
    const aRating = calculateCustomRating(a, maxRating, maxUserRating);
    const bRating = calculateCustomRating(b, maxRating, maxUserRating);
    return bRating - aRating;
  });
};
